import React from 'react'
import axios from 'axios'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import Login from './pages/Login'
import ResetPassword from './pages/ResetPassword'
import Dashboard from './pages/Dashboard'
import Products from './pages/Products'
import Segments from './pages/Segments'
import Users from './pages/Users'
import SmartBot from './pages/SmartBot'
import Setup from './pages/Setup'
import Brands from './pages/Brands'
import Influencers from './pages/Influencers'
import Quiz from './pages/Quiz'
import InfluencerDashboard from './pages/InfluencerDashboard'
import SmartEvent from './pages/SmartEvent'
import SmartTarget from './pages/SmartTarget'
import SmartMailing from './pages/SmartMailing'
import SmartBlog from './pages/SmartBlog'
import SmartCart from './pages/SmartCart'
import SmartSearch from './pages/SmartSearch'
import SmartCIP from './pages/SmartCIP'
import SmartLibrary from './pages/SmartLibrary'
import SmartView from './pages/SmartView'
import SmartReview from './pages/SmartReview'
import SmartContent from './pages/SmartContent'
import SmartGeo from './pages/SmartGeo'
import SmartSgo from './pages/SmartSgo'
import SmartShowcase from './pages/SmartShowcase'
import SmartVideo from './pages/SmartVideo'
import SmartRanking from './pages/SmartRanking'
import SmartAnalysis from './pages/SmartAnalysis'
import AuditLogs from './pages/AuditLogs'
import SystemMonitor from './pages/SystemMonitor'
import Layout from './components/Layout'
import { useBrand } from './context/BrandContext'
import { canAccessFeature } from './config/features'

const ANA_API = process.env.REACT_APP_API_URL || 'http://localhost:3000'

axios.interceptors.response.use(
  response => response,
  error => {
    const status = error.response && error.response.status
    const url = (error.config && error.config.url) || ''
    const baskaSunucu = /^https?:\/\//i.test(url) && !url.startsWith(ANA_API)
    if (status === 401 && !baskaSunucu && !url.includes('/admin/login') && !url.includes('/admin/password-reset')) {
      localStorage.removeItem('adminToken')
      localStorage.removeItem('adminAccount')
      if (window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
    }
    return Promise.reject(error)
  }
)

function PrivateRoute({ children }) {
  const token = localStorage.getItem('adminToken')
  return token ? children : <Navigate to="/login" />
}

// brand_admin kapalı bir modüle URL'den girerse Dashboard'a yönlendir
function FeatureRoute({ k, children }) {
  const { account } = useBrand() || {}
  return canAccessFeature(account, k) ? children : <Navigate to="/" replace />
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/sifre-sifirla" element={<ResetPassword />} />
        <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="brands" element={<Brands />} />
          <Route path="products" element={<FeatureRoute k="products"><Products /></FeatureRoute>} />
          <Route path="segments" element={<FeatureRoute k="segments"><Segments /></FeatureRoute>} />
          <Route path="setup" element={<Setup />} />
          <Route path="users" element={<Users />} />
          <Route path="smartbot" element={<FeatureRoute k="smartbot"><SmartBot /></FeatureRoute>} />
          <Route path="influencers" element={<FeatureRoute k="influencers"><Influencers /></FeatureRoute>} />
          <Route path="influencer-dashboard" element={<FeatureRoute k="influencer-dashboard"><InfluencerDashboard /></FeatureRoute>} />
          <Route path="quiz" element={<FeatureRoute k="quiz"><Quiz /></FeatureRoute>} />
          <Route path="smart-event" element={<FeatureRoute k="smart-event"><SmartEvent /></FeatureRoute>} />
          <Route path="smart-target" element={<FeatureRoute k="smart-target"><SmartTarget /></FeatureRoute>} />
          <Route path="smart-mailing" element={<FeatureRoute k="smart-mailing"><SmartMailing /></FeatureRoute>} />
          <Route path="smart-blog" element={<FeatureRoute k="smart-blog"><SmartBlog /></FeatureRoute>} />
          <Route path="smart-cart" element={<FeatureRoute k="smart-cart"><SmartCart /></FeatureRoute>} />
          <Route path="smart-search" element={<FeatureRoute k="smart-search"><SmartSearch /></FeatureRoute>} />
          <Route path="smart-cip" element={<FeatureRoute k="smart-cip"><SmartCIP /></FeatureRoute>} />
          <Route path="smart-library" element={<FeatureRoute k="smart-library"><SmartLibrary /></FeatureRoute>} />
          <Route path="smart-view" element={<FeatureRoute k="smart-view"><SmartView /></FeatureRoute>} />
          <Route path="smart-review" element={<FeatureRoute k="smart-review"><SmartReview /></FeatureRoute>} />
          <Route path="smart-content" element={<FeatureRoute k="smart-content"><SmartContent /></FeatureRoute>} />
          <Route path="smart-geo" element={<FeatureRoute k="smart-geo"><SmartGeo /></FeatureRoute>} />
          <Route path="smart-sgo" element={<FeatureRoute k="smart-sgo"><SmartSgo /></FeatureRoute>} />
          <Route path="smart-showcase" element={<FeatureRoute k="smart-showcase"><SmartShowcase /></FeatureRoute>} />
          <Route path="smart-video" element={<FeatureRoute k="smart-video"><SmartVideo /></FeatureRoute>} />
          <Route path="smart-ranking" element={<FeatureRoute k="smart-ranking"><SmartRanking /></FeatureRoute>} />
          <Route path="smart-analysis" element={<FeatureRoute k="smart-analysis"><SmartAnalysis /></FeatureRoute>} />
          <Route path="audit-logs" element={<AuditLogs />} />
          <Route path="system-monitor" element={<SystemMonitor />} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default App